<template>
  <div class="border-gray-300 rounded-lg ml-20 mr-5 py-2 pl-4">
    <div
      class="w-24 h-24 border border-dashed border-gray-300 cursor-pointer"
      @click="handleGetEditor"
    >
      <img class=" w-full h-full" src="./editor.svg" alt="" />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Content } from '@forchange/storytime';

@Component
export default class CodeBlock extends Vue {
  @Prop({ type: Object }) content!: Content & { code: string };
  mounted() {
    this.handleGetEditor();
  }
  handleGetEditor() {
    this.$emit('enterEditor', this.content.code);
  }
}
</script>
